import api from '@/utils/api';

/**
 * Update CompanyProduct
 * @param {string} id Company id
 * @param {object} data - The CompanyProduct order data
 * @param {string} data.id Product id
 * @param {string} data.order Order
 * @returns {Promise}
 */
const updateCompanyProductOrderApi = (id, data) =>
  api.patch(`/company/${id}/product/order`, data);

export default updateCompanyProductOrderApi;
